import PageAccess from 'lib/authorization/PageAccess'
import { pagePrivileges } from 'lib/authorization/PagePrivileges'

const ApplicationPageAccess = (clientFeatures: any) => {
  return PageAccess(pagePrivileges, clientFeatures)
}

export default ApplicationPageAccess
